module.exports = __webpack_public_path__ + "media/icons/key-5-a440e9ed.svg";